import { render, staticRenderFns } from "./JustifiedHeaderText.vue?vue&type=template&id=79047680&scoped=true"
import script from "./JustifiedHeaderText.vue?vue&type=script&lang=js"
export * from "./JustifiedHeaderText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79047680",
  null
  
)

export default component.exports